var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ImageCropper", {
        attrs: { dialog: _vm.dialog, image: _vm.image },
        on: {
          closeModal: _vm.handleCloseModal,
          imageCropped: _vm.handleImageCropped,
        },
      }),
      _c(
        "label",
        {
          staticClass: "block text-sm leading-5 font-medium text-gray-700",
          attrs: { for: "photo" },
        },
        [_vm._v(" " + _vm._s(_vm.labelText) + " ")]
      ),
      _c("div", { staticClass: "mt-2 sm:mt-0 sm:col-span-2" }, [
        _c(
          "div",
          { staticClass: "flex items-center" },
          [
            _vm.filepath
              ? [
                  _c(
                    "Processing",
                    {
                      staticClass: "processingCircle",
                      attrs: { processing: _vm.processing, spinner: "" },
                    },
                    [
                      _c("img", {
                        staticClass: "inline-block h-14 w-14 rounded-full",
                        attrs: { src: _vm.filepath, alt: "" },
                      }),
                    ]
                  ),
                ]
              : [
                  _c(
                    "span",
                    {
                      staticClass:
                        "h-12 w-12 rounded-full overflow-hidden bg-gray-100",
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "h-full w-full text-gray-300",
                          attrs: { fill: "currentColor", viewBox: "0 0 24 24" },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
            _c("span", { staticClass: "ml-5 rounded-sm shadow-sm" }, [
              _c("input", {
                ref: "fileUpload",
                attrs: { type: "file", hidden: "", accept: "image/*" },
                on: { change: _vm.filesChange },
              }),
              _c(
                "button",
                {
                  staticClass:
                    "py-2 px-3 border border-gray-300 rounded-sm text-sm leading-4 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-primary active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out",
                  attrs: { type: "button" },
                  on: { click: _vm.chooseFiles },
                },
                [_vm._v(" Change ")]
              ),
            ]),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }